<template>
    <div class="infoView">
        <el-carousel :interval="2000" arrow="always" direction="vertical" height="60px" indicator-position="none">
            <el-carousel-item class="liFlexRow" v-for="(item,index) in infoList" :key="index">
                <div class="noticeIcon"><i class="iconfont iconxinbaniconshangchuan-"></i></div>
                <div class="infoLiStyle">{{item.date}}</div>
                <div class="bookIcon"><i class="iconfont iconshuben"></i></div>
                <div class="infoLiStyle">{{item.content}}</div>
                <div class="infoLiStyle">{{item.author}}</div>
                <div class="infoLiStyle">{{item.operation}}</div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    name: 'Info',
    data() {
        return {
            infoList: [
                {
                    date: '一分钟前',
                    content: '轨道交通专业知识-1',
                    author: '刘英勇1',
                    operation: '上传'
                },
                {
                    date: '两分钟前',
                    content: '轨道交通专业知识-1',
                    author: '刘英勇2',
                    operation: '上传'
                },
                {
                    date: '三分钟前',
                    content: '轨道交通专业知识-1',
                    author: '刘英勇3',
                    operation: '上传'
                }
            ]
        }
    }
}
</script>

<style>
    .infoView {
        width: 100%;
        height: 60px;
        line-height: 60px;
        background: #e8ebfa;
        opacity: 0.7;
        margin-top: 30px;
    }
    .infoView .el-carousel__item {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .liFlexRow {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .infoLiStyle {
        margin-right: 90px;
        font-size: 18px;
        font-weight: 400;
        font-family: 'Microsoft YaHei';
        color: #333333;
    }
    .noticeIcon {
        margin-right: 40px;
    }
    .bookIcon {
        color: #22c6b6;
    }
</style>


// WEBPACK FOOTER //
// src/components/ivew/info.vue